export const REQUEST = {
  VALIDATE_REMEDIATION_CUSTOMER: '/remediation',
};
